import { AddToCartButton } from "@shopify/hydrogen-react";
import type { AddToCartButtonProps } from "@shopify/hydrogen-react/dist/types/AddToCartButton";
import { Button } from "atoms";

type AddToCartProps = Omit<AddToCartButtonProps, "children" | "quantity"> & {
  quantity?: number;
};

function AddToCart({ quantity = 1, variantId, ...props }: AddToCartProps) {
  return (
    <AddToCartButton
      as={Button}
      disabled={!variantId}
      {...props}
      quantity={quantity}
      variantId={variantId}
    >
      Add to Cart
    </AddToCartButton>
  );
}

export { AddToCart };
